/* ----------------------------------------- digital signature ----------------------------------------- */
// noinspection JSUnusedLocalSymbols
// eslint-disable-file no-unused-vars

const sc = window.crypto.subtle;

const keyAlgorithm = { name: 'ECDSA', namedCurve: 'P-256' };
const sigAlgorithm = { name: 'ECDSA', hash: { name: 'SHA-256' }};

const exportedKeyPair = {
    privateKey: null,
    publicKey: null
};

const importedKeyPair = {
    privateKey: null,
    publicKey: null
};

async function generateKeys() {
    let keyPair = await sc.generateKey(keyAlgorithm, true, ['sign', 'verify']);

    let exported = await sc.exportKey('jwk', keyPair.privateKey);
    exportedKeyPair.privateKey = JSON.parse(JSON.stringify(exported));

    console.log('exported PRIVATE key:');
    console.log(JSON.stringify(exportedKeyPair.privateKey));

    exported = await sc.exportKey('jwk', keyPair.publicKey);
    exportedKeyPair.publicKey = JSON.parse(JSON.stringify(exported));

    console.log('exported PUBLIC key:');
    console.log(JSON.stringify(exportedKeyPair.publicKey));
}

async function importKeys() {
    importedKeyPair.privateKey = await sc.importKey('jwk', exportedKeyPair.privateKey, keyAlgorithm, true, ['sign']);
    importedKeyPair.publicKey = await sc.importKey('jwk', exportedKeyPair.publicKey, keyAlgorithm, true, ['verify']);
}

async function signMessage(privateKey, message) {
    const encoded = new TextEncoder().encode(message);

    return await sc.sign(sigAlgorithm, privateKey, encoded);
}

async function verifyMessage(publicKey, message, signature) {
    const encoded = new TextEncoder().encode(message);

    return await sc.verify(sigAlgorithm, publicKey, signature, encoded);
}

function ab2str(arrayBuffer) {
    return String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
}

export function str2uia(str) {
    const uia = new Uint8Array(str.length);

    for (let i = 0; i < str.length; i++) {
        uia[i] = str.charCodeAt(i);
    }

    return uia;
}

// async function runTest() {
//     const message = 'Úžasně žluťoučký kůň pěl ďábelské ódy!';
//
//     await generateKeys();
//     await importKeys();
//
//     console.log('sign start...');
//     let signature = ab2str(await signMessage(importedKeyPair.privateKey, message));
//     console.log('signature (length ' + signature.length + ' bytes): ' + signature);
//
//     console.log('verify start...');
//     let result = await verifyMessage(importedKeyPair.publicKey, message, str2uia(signature));
//     console.log('Digital signature is ' + (result ? 'ok' : 'NOT ok'));
// }

//runTest();